const yesNoData = () => {
    const data =  [
        {id: 1, title: 'Yes'},
        {id: 2, title: 'No'}
    ];
    return data;
}
const yesNoOption = [
        {id: 1, title: 'Yes'},
        {id: 2, title: 'No'}
    ];
const yesNoValue = {
    // const data =  {
        1: 'Yes',
        2: 'No'
    // };
    // return data;
}
const optionDisValue = {
    // const data =  {
        1: 'Within 1km',
        2: 'Online',
        3: 'None of the above'
    // };
}
const optionAddressValue = {
    1: 'Online',
    2: 'Physical'
}
const optionSatisValue = {
    1: 'Very satisfied',
    2: 'Somewhat satisfied',
    3: 'Neither satisfied nor dissatisfied',
    4: 'Somewhat dissatisfied',
    5: 'Not at all satisfied'
}
const optionAchiveKPI = {
    1: 'Achieved the KPI',
    2: 'Fell short of the KPI',
    3: 'Exceeded the KPI'
}
const optionSatisfaction = () => {
    const data =  [
        {id: 1, title: 'Very satisfied'},
        {id: 2, title: 'Somewhat satisfied'},
        {id: 3, title: 'Neither satisfied nor dissatisfied'},
        {id: 4, title: 'Somewhat dissatisfied'},
        {id: 5, title: 'Not at all satisfied'}
    ];
    return data;
}
const optionStageData = [{id: 1, stage: 'Stage 1'},
                {id: 2, stage: 'Stage 2'},
                {id: 3, stage: 'Stage 3'},
                {id: 4, stage: 'Stage 4'},
                {id: 5, stage: 'Stage 5'},
                {id: 6, stage: 'Stage 6'}];
const instituteType = [
    {id: 1, type: 'School'},
    {id: 2, type: 'College'},
    {id: 3, type: 'Organisation'},
    {id: 0, type: 'Others'}
];
const instituteTypeObj = {
    1: 'School',
    2: 'College',
    3: 'Organisation',
    0: 'Others'
};
// School Nomination
const nominationGroupOptions = [{id: 1, type: 'Only one school'}, {id: 2, type: 'A group of schools'}];
// const nominationProgramOptions = [{id: 1, label: 'IFSPD Europe Future Global Leaders Fellowship for the top 10% students - from 6th grade onwards.'}, {id: 2, label: 'PortAhead.com to unlock BestFit colleges and global opportunities aligned to student goals and achievements - from 8th grade onwards.'}];
// const monthOption = [
//     {id: 1, label: 'Jan'},
//     {id: 2, label: 'Feb'},
//     {id: 3, label: 'Mar'},
//     {id: 4, label: 'Apr'},
//     {id: 5, label: 'May'},
//     {id: 6, label: 'Jun'},
//     {id: 7, label: 'Jul'},
//     {id: 8, label: 'Aug'},
//     {id: 9, label: 'Sep'},
//     {id: 10, label: 'Oct'},
//     {id: 11, label: 'Nov'},
//     {id: 12, label: 'Dec'},
// ];

const schoolBoardOption = [
                        {id: 17, label: "State Board"},
                        {id: 1, label: "CBSE"},
                        {id: 3, label: "ICSE"},
                        {id: 2, label: "IB"},
                        {id: 4, label: "IGCSE"},
                        {id: 0, label: "Others"},
                    ];

const schoolTypeOption = [
                        {id: 19, label: "Fully Residential"},
                        {id: 20, label: "Fully Day Scholar"},
                        {id: 21, label: "Mixed (both residential and day scholar students)"}
                    ];

export {yesNoData,
        yesNoValue,
        optionDisValue,
        optionAddressValue,
        optionSatisValue,
        optionSatisfaction,
        optionStageData,
        optionAchiveKPI,
        yesNoOption,
        instituteType,
        instituteTypeObj,
        nominationGroupOptions,
        // monthOption,
        schoolBoardOption,
        schoolTypeOption
    };